// extracted by mini-css-extract-plugin
module.exports = {"root":"select_root__2tqZl","selectWrapper":"select_selectWrapper__1HiEK","arrow":"select_arrow__UU0nr","select":"select_select__j6Cui"};